import { render, staticRenderFns } from "./LoadPage.vue?vue&type=template&id=b2c782be&scoped=true&"
import script from "./LoadPage.vue?vue&type=script&lang=js&"
export * from "./LoadPage.vue?vue&type=script&lang=js&"
import style0 from "./LoadPage.vue?vue&type=style&index=0&id=b2c782be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c782be",
  null
  
)

export default component.exports